var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGrid = function SvgGrid(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 4.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM1 15.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM12 4.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM12 15.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGrid);
export default ForwardRef;